import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { PhoneCall, Phone, AlertTriangle } from 'lucide-react';
import { CallOutcomeDialog } from './CallOutcomeDialog';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const hora = (iso) => new Date(iso).toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Lisbon' });
const dia = (iso) => new Date(iso).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', timeZone: 'Europe/Lisbon' });

const Item = ({ l, late, onCall }) => {
  const navigate = useNavigate();
  return (
    <div className={`flex items-center gap-3 rounded-xl px-3 py-2.5 border ${late || l.passou ? 'border-rose-200 bg-rose-50' : 'border-emerald-100 bg-white'}`} data-testid={`agenda-hoje-${l.id}`}>
      <span className={`text-base font-bold font-[Outfit] w-14 shrink-0 ${late || l.passou ? 'text-rose-600' : 'text-emerald-700'}`}>{late ? dia(l.next_action_at) : hora(l.next_action_at)}</span>
      <button type="button" onClick={() => navigate(`/leads/${l.id}`)} className="flex-1 min-w-0 text-left">
        <p className="text-sm font-semibold text-slate-800 truncate">{l.client_name}</p>
        <p className="text-xs text-slate-500 truncate">{l.client_phone}{l.last_contact_note ? ` · ${l.last_contact_note}` : ''}</p>
      </button>
      {l.client_phone && (
        <a href={`tel:${String(l.client_phone).replace(/\s/g, '')}`} onClick={() => setTimeout(() => onCall(l), 400)}
          className="flex items-center gap-1 text-xs font-semibold bg-emerald-600 hover:bg-emerald-700 text-white rounded-full px-3 py-2 transition-colors shrink-0"
          data-testid={`agenda-hoje-call-${l.id}`}><Phone className="w-3.5 h-3.5" />Ligar</a>
      )}
    </div>
  );
};

export const ChamadasHojeCard = () => {
  const [d, setD] = useState(null);
  const [callLead, setCallLead] = useState(null);
  const load = useCallback(() => { axios.get(`${API_URL}/leads/agenda-hoje`).then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);
  if (!d || (!d.hoje.length && !d.atrasadas_total)) return null;
  return (
    <div className="rounded-2xl border-2 border-emerald-200 bg-emerald-50/40 p-4 space-y-2" data-testid="chamadas-hoje-card">
      <div className="flex items-center justify-between">
        <h2 className="text-base md:text-lg font-bold text-[#2D3E6F] flex items-center gap-2"><PhoneCall className="w-5 h-5 text-emerald-600" />Chamadas de hoje ({d.hoje.length})</h2>
        <Link to="/leads/pipeline" className="text-xs text-[#2D3E6F] hover:underline">Ver pipeline →</Link>
      </div>
      {d.hoje.length === 0 && <p className="text-sm text-slate-500">Sem chamadas agendadas para hoje.</p>}
      {d.hoje.map((l) => <Item key={l.id} l={l} onCall={setCallLead} />)}
      {d.atrasadas_total > 0 && (
        <details className="pt-1" data-testid="chamadas-atrasadas">
          <summary className="text-sm font-semibold text-rose-700 cursor-pointer flex items-center gap-1"><AlertTriangle className="w-4 h-4" />{d.atrasadas_total} chamada(s) atrasada(s) de dias anteriores</summary>
          <div className="space-y-2 mt-2">{d.atrasadas.map((l) => <Item key={l.id} l={l} late onCall={setCallLead} />)}</div>
        </details>
      )}
      <CallOutcomeDialog lead={callLead} onClose={() => setCallLead(null)} onSaved={load} />
    </div>
  );
};
